import { plum } from '@/styles/colors';

export const ActiveDot = ({ sx }: { sx?: any }) => (
  <span
    style={{
      fontSize: '18px',
      color: plum[9],
      textShadow: '-2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff, 2px 2px 0 #fff',
      cursor: 'pointer',
      ...sx
    }}>
    •
  </span>
);
